import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.83323 6.63985C1.83323 4.20431 3.80763 2.22992 6.24318 2.22992C8.67873 2.22992 10.6531 4.20431 10.6531 6.63985C10.6531 7.8503 10.1654 8.94686 9.37583 9.74374C9.3708 9.74851 9.36581 9.75336 9.36087 9.7583C9.35597 9.7632 9.35115 9.76815 9.34641 9.77315C8.54959 10.5624 7.45331 11.0498 6.24318 11.0498C3.80764 11.0498 1.83323 9.07539 1.83323 6.63985ZM9.86307 11.333C8.86181 12.1065 7.60623 12.5666 6.24318 12.5666C2.96993 12.5666 0.316433 9.9131 0.316433 6.63985C0.316433 3.3666 2.96994 0.713124 6.24318 0.713124C9.51642 0.713124 12.1699 3.3666 12.1699 6.63985C12.1699 8.00329 11.7095 9.25921 10.9357 10.2606L14.8122 14.1371C15.1083 14.4333 15.1083 14.9135 14.8122 15.2097C14.516 15.5058 14.0358 15.5058 13.7396 15.2097L9.86307 11.333Z",
		fill: "#7C7C7C"
	})
});
export default SvgSearch;
